// The white panel every detail section sits in. One component so the twelve
// blocks on the page can never drift apart.
const DetailBlock = ({ title, badge, children, className = "" }) => (
  <section
    className={`mb-3 rounded-lg border border-light_gray bg-white p-4 shadow-card ${className}`}
  >
    {title && (
      <h2 className="mb-2 flex items-center gap-2 text-xs font-extrabold uppercase tracking-wide text-dark_gray">
        {title}
        {badge && (
          <span className="rounded-sm bg-light_green px-2 py-0.5 text-[10px] font-bold normal-case tracking-normal text-secondary">
            {badge}
          </span>
        )}
      </h2>
    )}
    {children}
  </section>
);

/** A label/value row inside a block. Renders nothing when there is no value. */
export const DetailRow = ({ label, value }) =>
  value ? (
    <div className="flex justify-between gap-4 py-0.5 text-sm">
      <span className="text-gray-400">{label}</span>
      <span className="text-right text-secondary">{value}</span>
    </div>
  ) : null;

export default DetailBlock;
